module.exports = __webpack_public_path__ + "img/8d2d579f89f0df5bb628ff96ee34f78e.png";